module.exports = __webpack_public_path__ + "static/media/019.71bd2b4c.jpg";